"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Source: https://www.w3.org/TR/webaudio/#oscillator-coefficients

var imag = exports.imag = Array.from({ length: 8192 }, function (_, n) {
  return n === 1 ? 1 : 0;
});

var real = exports.real = imag.map(function () {
  return 0;
});